const testimonials = [
  {
    name: "Sarah M.",
    location: "Boise, ID",
    rating: 5,
    text: "My passport expired the week before a work trip to Canada. Fast Passport Center had my renewal done in 4 days. I didn't have to drive to Seattle or wait weeks at the post office. Absolutely incredible service.",
    service: "Expedited Renewal",
  },
  {
    name: "James K.",
    location: "Meridian, ID",
    rating: 5,
    text: "First time applying for a passport and I had no idea what I was doing. The agent walked me through everything — forms, photo, which acceptance facility near me to use. Got my passport in under 2 weeks.",
    service: "New Application",
  },
  {
    name: "Lisa T.",
    location: "Eagle, ID",
    rating: 5,
    text: "My daughter's passport was lost a month before our family trip to Mexico. I thought we were doomed. Fast Passport Center handled the DS-64, new application, and had her passport delivered in 6 days. Heroes.",
    service: "Lost Passport",
  },
];

export default function TestimonialsSection() {
  return (
    <section id="reviews" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Boise Travelers Are Saying
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base leading-relaxed">
            Real customers from Boise, Meridian, Eagle, and the surrounding area.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6">
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <i key={j} className="ri-star-fill text-[#F6C344] text-sm"></i>
                ))}
              </div>
              <p className="text-gray-600 text-sm leading-relaxed mb-4 italic">&ldquo;{t.text}&rdquo;</p>
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="bg-[#EEF2F8] text-[#1A365D] text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}